import React, { useState, useEffect, useCallback, useMemo } from 'react';
import moment from 'moment';

import GraphDataTable from '../GraphDataVisualization/GraphDataTable';

import { useSelectedDevice } from '../../services/DeviceService/DevicesHooks';
import { useGlobalStore } from '../../services/GlobalStoreService/GlobalStoreHooks';

import './device-inventory.scss';

export default function DeviceDashboard({ globalFilter, ...props }) {
    const [, setContainerMeasures] = useState({ width: 0, height: 0 });
    const [selectedDeviceData, , changeSelection] = useSelectedDevice();
    const [mode, ] = useGlobalStore('mode');
    const [flipper, flip] = useState(true);

    const measureContainer = useCallback(node => {
        if (node !== null) {
            const boxSize = node.getBoundingClientRect();
            setContainerMeasures(prev => {
                return {
                    width: boxSize.width,
                    height: boxSize.height,
                };
            });
        }
    }, []);

    useEffect(() => {
        flip(prev => !prev);
    }, [selectedDeviceData]);

    const dataTableOptions = useMemo(() => {
        return {
            title: 'Full Device Inventory',
            className: '',
            options: {
                refresh: true,
                globalFilter,
                onRowClick: item => {
                    if (mode !== 'EDIT') {
                        if (item['code'] !== undefined) {
                            changeSelection(item['code']);
                        }
                    }
                },
                columns: [
                    {
                        key: 'organizationId',
                        header: 'Organization',
                        filterEnabled: true,
                    },
                    {
                        key: 'name',
                        header: 'Name',
                        filterEnabled: true,
                    },
                    {
                        key: 'code',
                        header: 'Device Code',
                        filterEnabled: true,
                    },
                    {
                        key: 'type',
                        header: 'Type',
                        filterEnabled: true,
                    },
                    {
                        key: 'locationName',
                        header: 'Location',
                        filterEnabled: true,
                    },
                    {
                        key: 'lifeCycleStatus',
                        header: 'Device Status',
                        filterEnabled: true,
                    },
                    {
                        key: 'testStatus',
                        header: 'Test Status',
                        filterEnabled: true,
                    },
                    {
                        key: 'testStatusUpdatedAt',
                        header: 'Test Status Update',
                        filterEnabled: true,
                        content: (value, rowData, column) => {
                            return moment(value).format('LLL');
                        },
                    },
                ],
            },
        };
    }, [globalFilter]);

    const narrowMode = selectedDeviceData !== null;

    return (
        <div className={`device-inventory-dashboard ${narrowMode ? 'narrow-mode' : ''}`}>
            <div className={`dashboard-column`} ref={measureContainer}>
                <div className="dashboard-row">
                    <GraphDataTable {...dataTableOptions} />
                </div>
            </div>
        </div>
    );
}
